import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Instagram } from "lucide-react";
import { STUDIO } from "../lib/content";

const links = [
  { to: "/", label: "Accueil" },
  { to: "/galerie", label: "Galerie" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [pathname]);

  const onHero = pathname === "/" && !scrolled;

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-[100] transition-[background-color,backdrop-filter,border-color] duration-500 ${
        scrolled
          ? "bg-[#F4F1EB]/80 backdrop-blur-md border-b border-[#1C1A18]/5"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div
		className={`max-w-[1600px] mx-auto px-6 md:px-12 h-20 flex items-center justify-between transition-colors duration-500 ${
          onHero ? "text-[#F4F1EB]" : "text-[#1C1A18]"
        }`}
      >
        {/* On a mis le logo DANS le Link, et ajouté "flex items-center gap-3" */}
        <Link
          to="/"
          data-testid="logo-link"
          className="flex items-center gap-3 font-hero-sq text-xl md:text-[22px] font-semibold tracking-tight leading-none"
        >
          <img 
            src="/images/logo.png" 
            alt="Logo L'écho du copeau" 
            className="h-9 w-auto object-contain" 
          />
          <span>{STUDIO.name}</span>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="group relative text-sm uppercase tracking-[0.15em] font-medium"
            >
              {l.label}
              <span
                className={`absolute -bottom-1.5 left-0 h-px bg-[#8B5A33] transition-[width] duration-500 ease-out ${
                  pathname === l.to ? "w-full" : "w-0 group-hover:w-full"
                }`}
              />
            </Link>
          ))}
          
        </nav>

        <button
          data-testid="menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden text-[#1C1A18]"
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="mobile-menu"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            className="md:hidden overflow-hidden bg-[#F4F1EB] border-t border-[#1C1A18]/10"
          >
            <div className="px-6 py-8 flex flex-col gap-6">
              {links.map((l) => (
                <Link
                  key={l.to}
                  to={l.to}
                  data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                  className="font-serif-el text-4xl"
                >
                  {l.label}
                </Link>
              ))}
              
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};
